import React from 'react';
import { CheckCircleIcon, ShieldCheckIcon, UsersIcon, TruckIcon } from 'lucide-react';
export const About = () => {
  const stats = [{
    value: '0+',
    label: 'Happy Customers'
  }, {
    value: '0%',
    label: 'Service Guarantee'
  }, {
    value: '0',
    label: 'Crews'
  }, {
    value: '0+',
    label: 'Cleans Completed'
  }];
  const features = [{
    title: 'Locally Owned & Operated',
    description: 'We are a local Charlotte, NC-based company committed to our community.',
    icon: <UsersIcon size={24} className="text-green-600" data-id="element-13" />
  }, {
    title: 'Reliable & Professional Service',
    description: 'We show up on time and complete the job to the highest standards.',
    icon: <ShieldCheckIcon size={24} className="text-green-600" data-id="element-14" />
  }, {
    title: 'Customer Satisfaction Guarantee',
    description: 'We are not satisfied until you are. We guarantee our work.',
    icon: <CheckCircleIcon size={24} className="text-green-600" data-id="element-15" />
  }, {
    title: 'Top-Notch Equipment & Techniques',
    description: 'We use the latest equipment and eco-friendly cleaning methods.',
    icon: <TruckIcon size={24} className="text-green-600" data-id="element-16" />
  }];
  return <section id="about" className="py-16 bg-white" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        {/* Main About Section */}
        <div className="flex flex-col lg:flex-row items-center gap-12 mb-16" data-id="element-19">
          <div className="lg:w-1/2" data-id="element-20">
            <div className="relative overflow-hidden rounded-lg shadow-xl h-96" data-id="element-21">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9uhHPdET7ChBDRzx3Ck47/IMG_7732.jpeg.jpg" alt="Pressure washing in action" className="w-full h-full object-cover" data-id="element-22" />
            </div>
          </div>
          <div className="lg:w-1/2" data-id="element-23">
            <h3 className="text-sm font-semibold text-green-600 mb-2" data-id="element-24">
              About Us
            </h3>
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-25">
              About Professor Pressure Washing LLC
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-26">
              At Professor Pressure Washing LLC, we take pride in providing
              top-quality exterior cleaning services in Charlotte, NC. Founded
              by Jeremy Martin, our company is built on decades of hard work,
              and a mission to deliver the best results every time.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-27">
              We are a family-owned business that has built a reputation for
              excellence in residential and commercial pressure washing,
              driveway cleaning, deck and fence washing, gutter cleaning, and
              roof washing.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-28">
              From day one, our goal has been to make Professor Pressure Washing
              LLC the go-to choice for exterior cleaning services in our
              community. We value honesty and business ethics and we strive to
              exceed all of your house cleaning needs.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-29">
              If you are in the Charlotte area and looking for a trusted
              exterior cleaning service, look no further than Professor Pressure
              Washing LLC—we are here to make your property shine!
            </p>
            <a href="#contact" className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-30">
              Contact Us
            </a>
          </div>
        </div>
        {/* Stats Section */}
        <div className="bg-green-900 text-white py-12 px-8 rounded-lg mb-16" data-id="element-31">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-32">
            {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-33">
                <p className="text-4xl font-bold mb-2" data-id="element-34">{stat.value}</p>
                <p className="text-green-200" data-id="element-35">{stat.label}</p>
              </div>)}
          </div>
        </div>
        {/* What Makes Us Stand Out Section */}
        <div className="mb-16" data-id="element-36">
          <div className="text-center mb-12" data-id="element-37">
            <h3 className="text-sm font-semibold text-green-600 mb-2" data-id="element-38">
              Excellence in Every Detail
            </h3>
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-39">
              What Makes Us Stand Out?
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-40">
            {features.map((feature, index) => <div key={index} className="text-center" data-id="element-41">
                <div className="flex justify-center mb-4" data-id="element-42">
                  <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center" data-id="element-43">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900" data-id="element-44">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-45">{feature.description}</p>
              </div>)}
          </div>
        </div>
        {/* Booking Steps Section */}
        <div className="bg-gray-50 py-12 -mx-4 px-4 md:-mx-0 md:px-0" data-id="element-46">
          <div className="container mx-auto px-4" data-id="element-47">
            <div className="text-center mb-12" data-id="element-48">
              <h3 className="text-sm font-semibold text-green-600 mb-2" data-id="element-49">
                Receive a quote in three simple steps
              </h3>
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-50">
                Booking Our Service is Easy!
              </h2>
            </div>
            <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-51">
              <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-52">
                <div className="w-12 h-12 bg-green-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-53">
                  1
                </div>
                <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-54">
                  Contact Us
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-55">
                  Give us a call at 980 500 9213 or send us a message
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-56">
                <div className="w-12 h-12 bg-green-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-57">
                  2
                </div>
                <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-58">
                  Discuss Requirement
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-59">
                  Let us know your cleaning needs and we will find the best
                  solution
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-60">
                <div className="w-12 h-12 bg-green-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-61">
                  3
                </div>
                <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-62">
                  Receive a Free Quote
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-63">
                  We will get back to you with our quote as soon as possible
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};